import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'qr-drop-down',
    templateUrl: './qr-drop-down.component.html',
    styleUrls: ['./qr-drop-down.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QrDropDownComponent implements OnInit {

    @Output() openChange = new EventEmitter<boolean>();
    // @Output() alternativeClick = new EventEmitter<void>();

    @Input() open: boolean = false;
    @Input() qrUrl: string = '';
    // @Input() browserAlternative: boolean = false;

    constructor() { }

    ngOnInit(): void {
    }
}
